export default (el) => el.innerHTML;
